import { useEffect, useRef } from "react";

import ClientManagementStore from "../../modules/Admin/ClientManagement/store";
import { MessageResultState } from "../../types/general-types";

const DEBOUNCE_MS = 1000;
const MIN_LENGTH = 3;

/** TR alanı yazılmayı bırakınca çevirip EN alanına yazar. */
export function useAutoTranslate(store?: ClientManagementStore) {
  const timer = useRef<number | null>(null);

  useEffect(
    () => () => {
      if (timer.current !== null) window.clearTimeout(timer.current);
    },
    []
  );

  return (value: string, apply: (translated: string) => void) => {
    if (timer.current !== null) window.clearTimeout(timer.current);

    timer.current = window.setTimeout(() => {
      if (!value || value.length < MIN_LENGTH) return;
      store?.Translation(value).then((response) => {
        if (response.state === MessageResultState.SUCCESS) apply(response.result);
      });
    }, DEBOUNCE_MS);
  };
}

export default useAutoTranslate;
